import React, { memo } from 'react'
import { Message } from '@paypalcorp/worldready-react'
import {
  Container,
  Row,
  Col,
  HeadingText,
  AccordionRow,
  Accordion,
  BodyText,
} from '@paypalcorp/pp-react'
import { PrivacyHubLink } from './common'
import { otherPageConfig } from '../../config/privacy-hub'
import serverData from '../../utils/server-data'

const {
  LinkBanksAndCardsData,
  whenYouShopData,
  whenYouPayOrGetPaid,
} = otherPageConfig

const customAccordion = (data) => {
  const {
    enabled,
    title,
    desc,
    desc2,
    list1,
    list2,
    list3,
    phone,
    footer,
    img,
    link,
    id,
  } = data
  if (!enabled) {
    return false
  }
  return (
    <>
      <Row>
        <Accordion name="privacyHubOthersAccordion">
          <AccordionRow
            headerClassName="privacy-hub-title-text"
            heading={<Message id={title} />}
            className="privacy-hub-accodion-col"
            id={`${id}Accordion`}
          >
            <BodyText className="privacy-hub-body-text" id={`${id}Desc1`}>
              <Message id={desc} />
            </BodyText>
            {desc2 && (
              <BodyText
                className="privacy-hub-body-text privacy-hub-other-accord-description"
                id={`${id}Desc2`}
              >
                <Message id={desc2} />
              </BodyText>
            )}
            <ul className="privacy-hub-other-ul">
              {list1 && (
                <li className="privacy-hub-unordered-list">
                  <BodyText
                    className="privacy-hub-body-text"
                    id={`${id}ListText1`}
                  >
                    <Message id={list1} />
                  </BodyText>
                </li>
              )}
              {phone && (
                <li className="privacy-hub-unordered-list">
                  <BodyText
                    className="privacy-hub-body-text"
                    id={`${id}ListPhone`}
                  >
                    <Message id={phone} />
                  </BodyText>
                </li>
              )}
              {list2 && (
                <li className="privacy-hub-unordered-list">
                  <BodyText
                    className="privacy-hub-body-text"
                    id={`${id}ListText2`}
                  >
                    <Message id={list2} />
                  </BodyText>
                </li>
              )}
              {list3 && (
                <li className="privacy-hub-unordered-list">
                  <BodyText
                    className="privacy-hub-body-text"
                    id={`${id}ListText3`}
                  >
                    <Message id={list3} />
                  </BodyText>
                </li>
              )}
            </ul>
            {footer && (
              <BodyText
                className="privacy-hub-body-text privacy-hub-other-accord-description"
                id={`${id}Footer`}
              >
                <Message id={footer} />
              </BodyText>
            )}
            {link && (
              <PrivacyHubLink
                message={link.text}
                href={link.href}
                name={link.name}
                id={`${id}Link`}
              />
            )}
            {img && (
              <div className="privacy-hub-others-accord-img">
                <img src={img.src} alt={img.alt} className={img.classname} />
              </div>
            )}
          </AccordionRow>
        </Accordion>
      </Row>
    </>
  )
}
const PrivacyHubOthers = memo(() => (
  <div id="privacy-hub-others">
    <Container className="privacy-hub-others-see-container">
      <Row
        noGutters
        className="privacy-hub-align-items-center privacy-hub-others-see-row"
      >
        <Col md={6} className="privacy-hub-col-spacing">
          <HeadingText
            size="hero"
            className="privacy-hub-display-text"
            id="privacyHubOthersHeading"
          >
            <Message id="privacyhub.home.otherssee.othersSee" />
          </HeadingText>
        </Col>
        <Col
          xs={12}
          md={6}
          className="privacy-hub-business-image-container privacy-hub-text-align-center"
        >
          <img
            className="privacy-hub-others-and-data-image"
            src={`https://${serverData.cdnHostName}/privacyhub/${serverData.country}/${serverData.language}/lunch-illustration.svg`}
            alt="money sent"
          />
        </Col>
      </Row>

      <Row noGutters className="privacy-hub-others-see-row">
        <Col md={6} className="privacy-hub-col-spacing">
          <HeadingText
            className="privacy-hub-data-page-title"
            id="payOrGetPaid"
          >
            <Message id="privacyhub.home.otherssee.payOrGetPaid" />
          </HeadingText>
        </Col>
        <Col md={5} className="privacy-hub-accodion-col">
          {whenYouPayOrGetPaid.map((accordion, index) => {
            return <div key={index}>{customAccordion(accordion)}</div>
          })}
        </Col>
      </Row>

      <Row noGutters className="privacy-hub-others-see-row">
        <Col md={6} className="privacy-hub-col-spacing">
          <HeadingText className="privacy-hub-data-page-title" id="shopData">
            <Message id="privacyhub.home.otherssee.shop" />
          </HeadingText>
        </Col>
        <Col md={5} className="privacy-hub-accodion-col">
          {whenYouShopData.map((accordion, index) => {
            return <div key={index}>{customAccordion(accordion)}</div>
          })}
        </Col>
      </Row>

      <Row noGutters className="privacy-hub-others-see-row">
        <Col md={6} className="privacy-hub-col-spacing">
          <HeadingText className="privacy-hub-data-page-title" id="linkBank">
            <Message id="privacyhub.home.otherssee.linkBank" />
          </HeadingText>
        </Col>
        <Col md={5} className="privacy-hub-accodion-col">
          {LinkBanksAndCardsData.map((accordion, index) => {
            return <div key={index}>{customAccordion(accordion)}</div>
          })}
        </Col>
      </Row>
    </Container>
  </div>
))

PrivacyHubOthers.displayName = 'PrivacyHubOthers'
export default PrivacyHubOthers
